import { useEffect, useEffectEvent, useState } from 'react';
import { InteractionManager, Platform } from 'react-native';

export function useBlurProps(props: { blurAmount: number }) {
  const [blurAmount, setBlurAmount] = useState(0);

  const applyProps = useEffectEvent(({ blurAmount: blurAmountProp }: { blurAmount: number }) => {
    setBlurAmount(blurAmountProp);
  });

  useEffect(() => {
    const blurAmountProp = props.blurAmount;
    const applyBlur = () => applyProps({ blurAmount: blurAmountProp });

    if (Platform.OS === 'ios') {
      const task = InteractionManager.runAfterInteractions(() => {
        const id = setTimeout(applyBlur, 100);
        return () => clearTimeout(id);
      });
      return () => task.cancel();
    }

    const id = requestAnimationFrame(applyBlur);
    return () => cancelAnimationFrame(id);
  }, [props.blurAmount]);

  return {
    blurAmount,
  };
}
